/** @file The numeric timelines the curve editor draws: key table, property, value mode, setup rule. */
import type { CurveChannel, CurveChannelSpec } from './curveTypes';

/** animation.setCurve channel name → where its keys live and how its values read; table order = draw order. */
export const CURVE_CHANNELS: Readonly<Record<CurveChannel, CurveChannelSpec>> = {
  rotation: { group: 'bones', prop: 'rotation', mode: 'value', setup: 'add' },
  x: { group: 'bones', prop: 'x', mode: 'value', setup: 'add' },
  y: { group: 'bones', prop: 'y', mode: 'value', setup: 'add' },
  scaleX: { group: 'bones', prop: 'scaleX', mode: 'value', setup: 'scale' },
  scaleY: { group: 'bones', prop: 'scaleY', mode: 'value', setup: 'scale' },
  shearX: { group: 'bones', prop: 'shearX', mode: 'value', setup: 'add' },
  shearY: { group: 'bones', prop: 'shearY', mode: 'value', setup: 'add' },
  alpha: { group: 'slots', prop: 'alpha', mode: 'value', setup: 'none' },
  rgb: { group: 'slots', prop: 'rgb', mode: 'progress', setup: 'none' },
  dark: { group: 'slots', prop: 'dark', mode: 'progress', setup: 'none' },
  ikMix: { group: 'ik', prop: 'mix', mode: 'value', setup: 'none' },
  ikSoftness: { group: 'ik', prop: 'softness', mode: 'value', setup: 'none' },
  deform: { group: 'deform', prop: '', mode: 'progress', setup: 'none' },
};
